import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from './../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.saveFrom)) {
    store.state.redirectPath = from.path
  } else {
    store.state.redirectPath = null
  }

  if (routeRequiresAuth(to)) {
    if (!store.state.authenticated) {
      store.state.redirectAfterLoginPath = to.path
      next({
        path: '/login'
      })
    } else {
      if (routeRequiresAdmin(to)) {
        if (store.getters.isAdmin) {
          next()
        } else {
          notify('warning', 'Ihr Benutzerkonto besitzt nicht die benötigte Berechtigung.')
          next({
            path: '/'
          })
        }
      } else if (routeRequiresNotUser(to)) {
        if (store.getters.isNotUser) {
          next()
        } else {
          notify('warning', 'Ihr Benutzerkonto besitzt nicht die benötigte Berechtigung.')
          next({
            path: '/'
          })
        }
      } else {
        next()
      }
    }
  } else if (routeRequiresGuest(to)) {
    if (store.state.authenticated) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})
router.beforeEach((to, from, next) => {
  // Check if VUE_APP_TITLE is defined, if not, use the default title
  const defaultTitle = 'Eder IT';
  const title = process.env.VUE_APP_TITLE || defaultTitle;

  document.title = title;
  next();
});
function routeRequiresAuth (to) {
  return to.matched.some(record => record.meta.requiresAuth)
}

function routeRequiresGuest (to) {
  return to.matched.some(record => record.meta.requiresGuest)
}

function routeRequiresAdmin (to) {
  return to.matched.some(record => record.meta.requiresAdmin)
}

function routeRequiresNotUser (to) {
  return to.matched.some(record => record.meta.requiresNotUser)
}

function notify (type, message) {
  router.app.$notify({ type, message })
}

export default router
